import styled from "@emotion/styled";
import { colors } from "@ui/style/colors";
import { Skeleton } from "primereact/skeleton";
import React, { ReactNode, useMemo } from "react";

export interface ConditionalSkeletonProps {
	active: boolean;
	loading?: boolean;
	children?: ReactNode;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export const ProgramSkeleton: React.FC<ConditionalSkeletonProps> = ({ active, loading = false, children }) => {
	const skeleton = useMemo(
		() =>
			active ? (
				<div className="p-panel p-component p-panel-toggleable">
					<div className="p-panel-header" style={{ paddingBottom: "18px" }}>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<span style={{ alignSelf: "flex-start" }}>
								<CustomSkeleton height="2rem" width="300px" animation={loading ? "wave" : "none"}></CustomSkeleton>
							</span>
							<span style={{ alignSelf: "flex-end" }}>
								<CustomSkeleton height="2rem" width="100px" animation={loading ? "wave" : "none"}></CustomSkeleton>
							</span>
						</div>
					</div>
					<ContentBox>
						<div className="p-panel-content">
							<div style={{ paddingBottom: 20 }}>
								<CustomSkeleton height="2rem" width="300px" animation={loading ? "wave" : "none"}></CustomSkeleton>
							</div>
							<div className="css-0">
								<div style={{ paddingBottom: 20 }}>
									<CustomSkeleton height="2rem" width="300px" animation={loading ? "wave" : "none"}></CustomSkeleton>
								</div>
								<div>
									<CustomSkeleton height="3rem" width="300px" animation={loading ? "wave" : "none"}></CustomSkeleton>
								</div>
							</div>
						</div>
					</ContentBox>
				</div>
			) : (
				<>{children}</>
			),
		[active, loading, children],
	);

	return active ? skeleton : <>{children}</>;
};

const ContentBox = styled.div`
	height: 100%;
	padding: 40px;
	border-radius: 8px;
	border: 1px solid #d5d5db;
	display: grid;
	grid-template-columns: 1fr 1fr;
	place-items: flex-start;
	grid-gap: 40px;
`;

const CustomSkeleton = styled(Skeleton)`
	background: ${colors.grey10};
`;
